import { debounce } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { post } from '../components/Auths/AuthToken';
import setUiMessage from './Tostify';

// Component for searching and tagging staff users
function SearchStaffUser({ fieldName, tagStaffUser, handleTaggedStaff }) {
  const [input, setInput] = useState('');
  const [stafList, setStafList] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState(tagStaffUser || []);
  const [isDivHidden, setIsDivHidden] = useState(true);
  const inputRef = useRef(null);

  // Effect to handle the tagged staff based on return type
  useEffect(() => {
    handleTaggedStaff(selectedStaff);
  }, [selectedStaff, handleTaggedStaff]);

  // Effect to handle clicks outside the input field
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (inputRef?.current && !inputRef?.current.contains(event.target)) {
        setIsDivHidden(true);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [inputRef]);

  // Debounce input changes to reduce API calls
  const debouncedInputData = debounce((e) => {
    setInput(e.target.value);
  }, 500);

  // Effect to fetch staff list based on input
  useEffect(() => {
    let isCancelled = false;
    if (input) {
      const fetchData = async () => {
        try {
          const response = await post(
            'api/communication/Communication/searchStaff',
            {
              searchStr: input,
            }
          );
          if (!isCancelled && response.status === 200) {
            setIsDivHidden(false);
            setStafList(response?.data?.searchStaffListArr);
          }
        } catch (err) {
          setUiMessage('suc', err.message);
        }
      };
      fetchData();
    } else {
      setStafList([]);
    }
    return () => {
      isCancelled = true;
    };
  }, [input]);

  // Function to handle selection of staff
  const handleSelectedStaff = (staff) => {
    if (selectedStaff.some((item) => item.staff_id === staff.userId)) {
      setUiMessage('err', 'Staff already added!');
    } else {
      setSelectedStaff([
        ...selectedStaff,
        { staffName: staff?.staffName, staff_id: staff?.userId },
      ]);
    }
  };

  // Function to handle deletion of selected staff
  const handleStaffDelete = (index) => {
    const updateSelectedStaff = [...selectedStaff];
    updateSelectedStaff.splice(index, 1);
    setSelectedStaff(updateSelectedStaff);
  };

  // Render the component
  return (
    <div
      ref={inputRef}
      className="comp-msg-bdy-rw grid-sec"
      style={{ position: 'relative' }}
    >
      {/* Input field for staff search */}
      {fieldName ? (
        <div className="comp-msg-bdy-chld-rw flex-sec">
          <span className="msg-bdy-rw-bl">{fieldName}:</span>
          <span className="msg-bdy-rw-val qwidth100">
            <input
              type="search"
              className="msg-inpt"
              placeholder="Search staff for tag"
              onChange={debouncedInputData}
            />
          </span>
        </div>
      ) : (
        <span className="msg-bdy-rw-val width100">
          <input
            type="search"
            className="msg-inpt"
            placeholder="Search staff for tag"
            onChange={debouncedInputData}
          />
        </span>
      )}

      {/* Display search results */}
      <div
        className={`search-user-pnl grid-sec ${isDivHidden ? 'hide' : ''}`}
        style={{ top: '37px', left: '129px', width: '76%' }}
      >
        {stafList
          ? stafList.map((item, i) => (
              <span
                key={i}
                className={`${
                  selectedStaff.some((obj) => obj.staff_id === item.userId)
                    ? `usr-name pat-rec-selected`
                    : `usr-name`
                }`}
                onClick={() => handleSelectedStaff(stafList[i])}
              >
                {item?.staffWithDegree}{' '}
                <span className="sec-colr">
                  {item?.sub_user_type ? ` (${item?.sub_user_type})` : ``}
                </span>
              </span>
            ))
          : ''}
      </div>

      {/* Display selected staff */}
      {selectedStaff.length > 0 && (
        <div
          className="comp-msg-bdy-chld-rw flex-sec"
          style={{ marginTop: '5px' }}
        >
          <div className="msg-bdy-rw-bl hide">&nbsp;</div>
          <div
            className="msg-bdy-rw-val atchd-ptnt-col flex-sec width100"
            style={{ flexFlow: 'wrap' }}
          >
            {selectedStaff &&
              selectedStaff.map((item, i) => (
                <div
                  key={i}
                  className="msg-chld-rw-atchd-ptnt flex-sec slctd-name"
                >
                  {/* Display selected staff details */}
                  <div className="slctd-name">
                    <span className="name">{item?.staffName}</span>
                  </div>
                  {/* Remove option */}
                  <div
                    className="slctd-name-rmv"
                    onClick={() => handleStaffDelete(i)}
                  >
                    X
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default SearchStaffUser;
